import { render, staticRenderFns } from "./PersonalSpace.vue?vue&type=template&id=6a01d36c&scoped=true"
import script from "./PersonalSpace.vue?vue&type=script&lang=js"
export * from "./PersonalSpace.vue?vue&type=script&lang=js"
import style0 from "./PersonalSpace.vue?vue&type=style&index=0&id=6a01d36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01d36c",
  null
  
)

export default component.exports